var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddnewfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    viewBox: "0 0 55 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 32.2648C2.17459 32.2648 2.61175 32.4533 2.9341 32.7886C3.25642 33.1241 3.4375 33.5791 3.4375 34.0534V42.997C3.4375 43.9456 3.79966 44.8556 4.44433 45.5264C5.08897 46.1974 5.96332 46.5743 6.875 46.5743H48.125C49.0367 46.5743 49.911 46.1974 50.5558 45.5264C51.2004 44.8556 51.5625 43.9456 51.5625 42.997V34.0534C51.5625 33.5791 51.7436 33.1241 52.0659 32.7886C52.3882 32.4533 52.8253 32.2648 53.2814 32.2648C53.7372 32.2648 54.1743 32.4533 54.4966 32.7886C54.8189 33.1241 55 33.5791 55 34.0534V42.997C55 44.8944 54.2758 46.7142 52.9863 48.056C51.6971 49.3977 49.9484 50.1516 48.125 50.1516H6.875C5.05164 50.1516 3.30295 49.3977 2.01364 48.056C0.724328 46.7142 0 44.8944 0 42.997V34.0534C0 33.5791 0.181082 33.1241 0.503411 32.7886C0.825739 32.4533 1.26291 32.2648 1.71875 32.2648Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2854 39.2531C26.4449 39.4199 26.6345 39.552 26.8433 39.6421C27.0523 39.7323 27.276 39.7787 27.5022 39.7787C27.7281 39.7787 27.9521 39.7323 28.1609 39.6421C28.3697 39.552 28.5593 39.4199 28.719 39.2531L39.0315 28.5212C39.3543 28.1852 39.5355 27.7298 39.5355 27.2546C39.5355 26.7796 39.3543 26.3242 39.0315 25.9883C38.7088 25.6525 38.271 25.4638 37.8147 25.4638C37.3582 25.4638 36.9204 25.6525 36.5977 25.9883L29.2208 33.6689V2.2131C29.2208 1.73871 29.0398 1.28375 28.7175 0.948302C28.3952 0.61286 27.958 0.424408 27.5022 0.424408C27.0464 0.424408 26.6092 0.61286 26.2869 0.948302C25.9644 1.28375 25.7833 1.73871 25.7833 2.2131V33.6689L18.4065 25.9883C18.0838 25.6525 17.6461 25.4638 17.1897 25.4638C16.7332 25.4638 16.2955 25.6525 15.9728 25.9883C15.6501 26.3242 15.4688 26.7796 15.4688 27.2546C15.4688 27.7298 15.6501 28.1852 15.9728 28.5212L26.2854 39.2531Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_1089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 51,
    fill: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddnewfile);
export default __webpack_public_path__ + "static/media/addnewfile.88d33444ea16ac6e25f6877eb4ad7639.svg";
export { ForwardRef as ReactComponent };